import { forwardRef, ReactNode } from 'react';
import { createButtonTheme } from 'theme';
import {
  ButtonProps,
  Stack,
  CircularProgress,
  CircularProgressProps,
  Button as MuiButton,
  ThemeProvider,
} from 'components/base';

export interface MuiButtonProps extends Omit<ButtonProps, 'variant'> {
  children: ReactNode;
  isLoading?: boolean;
  startIcon?: ReactNode;
  target?: '_blank' | '_self' | '_parent' | '_top';
  loaderProps?: CircularProgressProps;
  variant?:
    | 'contained'
    | 'outlined'
    | 'text'
    | 'outlinedPrimary'
    | 'outlinedSecondary'
    | 'containedPrimary'
    | 'containedSecondary'
    | 'textSecondary'
    | 'textPrimary'
    | 'containedError';
}

export const Button = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (
    {
      children,
      isLoading = false,
      startIcon,
      loaderProps,
      variant = 'contained',
      ...rest
    },
    ref,
  ) => (
    <ThemeProvider theme={createButtonTheme}>
      <MuiButton
        ref={ref}
        disabled={isLoading}
        target="_blank"
        variant={variant as ButtonProps['variant']}
        startIcon={
          <Stack alignItems="center" gap={0.2}>
            {isLoading ? (
              <CircularProgress size={18} color="inherit" {...loaderProps} />
            ) : (
              startIcon
            )}
          </Stack>
        }
        {...rest}
      >
        {children}
      </MuiButton>
    </ThemeProvider>
  ),
);
